import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import Slider from '../components/Slider';
import { poolsSlides } from '../data/data';
import InfoBlock from '../components/InfoBlock';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Pools = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Pools" />
      <InfoBlock
        tagLine="Transform Your Backyard with a Beautiful Pool"
        simpleText="Expert pool construction and installation tailored to your vision and budget."
      />
      <Slider poolsSlides={poolsSlides} />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Pools;
